export default {
    mfaLogin: {
        heading: "Two-factor authentication (2FA) Login",
        error: "Something went wrong, please refresh and try again. If the problem continues, please contact EdCity at <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>.",
        error04: "The Two-factor authentication login process could not be completed within time limit. Please login again.",
        error07: "This email address cannot be used for two-factor authentication login.",
        mfaEmailTitle: "Enable 2FA Login for School Admin",
        mfaEmailSubtitle: "Please provide an email address to enable 2FA login. A verification email will be sent to the email address provided.<br>1. School Admins can use their current login email for 2FA login.<br>2. An email address used for other EdCity accounts cannot be used as the 2FA login for a School Admin account.",
        mfaEmailRemind: "A verification email has been sent to the email address you provided. Please click here to continue the setup process. ",
        mfaEmailRemindSubtitle: "Kindly make the request again in case you did not receive the email or have other changes.",
        loginEmail: "Login Email",
        loginEmailError: "Invalid email address format",
        loginEmailHint: "This will be used to verify EdCity Login Email as two-factor authentication login",
        loginEmailUnaccepted: "This email domain is not accepted. Please use another email.",
        loginEmailInUse: "An EdCity account already exists with the email address. Please fill in another email address.",
        loginEmailPending: "This email address has already been used and is pending to be activated.",
        alreadyVerifiedAsTeacher: "An EdCity Individual Teacher account already exists with the email address. Please fill in another email address. ",
        completed: "A verification email has been sent to <span class='orangeText'>{loginEmail}</span>. Please click on the link inside to verify the setup on or before {expireAt}. After completing the verification, please click ‘Completed verification’ to continue the login process.",
        hold: "You have made more than 5 incorrect requests within the past 24 hours. Please try again after {displayDatetime}. ",
        wait: "2FA Login for School Admin had not been confirmed. Please click on the link inside the verification email to finish the verification process.",
    },
    mfaLoginEmailVerification: {
        heading: "Verified",
        mainMessage: "Confirmation to update login email and enable two-factor authentication login",
        success: "You have successfully updated your login email and enable two-factor authentication to {email}",
    },
    otpLogin: {
        heading: "One-time password login",
        error: "Invalid Login Email/Login ID",
        error01: "Something went wrong, please refresh and try again. If the problem continues, please contact EdCity at <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>.",
        error04: "The One-time password login process could not be completed within time limit. Please login again.",
        errorSchoolAdmin: "(For school admins, please use password to log-in)",
        loginEmail: "Login Email/Login ID",
        loginEmailError: "Invalid Login Email format or Login ID",
        otpEmailTitle: "Login using one-time password",
        otpEmailSubtitle: "A one-time password will be sent to your Login Email",
        hold:"You have made more than 5 incorrect requests within the past 24 hours. Please try again after {displayDatetime} or log in with your password.",
    },
    button: {
        back: "Log in again",
        submit: "Submit",
        verified: "Completed verification",
        login: "Login",
        send: "Send",
        resend: "Resend",
        close: "Back",
        more: " ...more",
    },
    text: {
        loginTitle: "Enter the one-time password",
        loginSubtitle: "Please enter the one-time password sent to your Login Email <span class='orangeText'>{loginEmail}</span>. If you cannot receive the one-time password, please contact us on <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>.",
        otp: "One-time password",
        verifySuccess:"Verify Successfully.",
        countdown:"Validity time of one-time password: ",
        codeExpired:"The one-time password has expired. Please resend and try again.",
        codeInvalid: "The code is invalid.",
        codeNotFound:"The corresponding record cannot be found, please go back and try again.",
    }
}